import React from 'react';

const HintLegend = ({ hints = [] }) => {
  return (
    <div className="flex items-center gap-4 mb-4">
      {hints.map((hint, index) => (
        <div key={index} className="flex items-center gap-06">
          <HintLegendItem hint={hint} />
          <span className="text-sm text-gray-600">{hint.label}</span>
        </div>
      ))}
    </div>
  );
};

export const HintLegendItem = ({ hint, isSmall }) => {
  return (
    <span
      style={{
        lineHeight: '3',
      }}
      className={`${
        isSmall
          ? 'w-3 h-3 min-w-12 min-h-12 text-8'
          : 'w-014 h-014 min-w-014 min-h-014 text-9'
      } font-bold rounded-full flex justify-center items-center text-center border border-solid ${
        hint.colorClasses
      }`}>
      {hint.letter}
    </span>
  );
};

export const getHintLegendByOriginStatus = (originStatus) => {
  switch (originStatus) {
    case 'AUTOBOOK':
      return {
        letter: 'A',
        label: 'Autobook',
        colorClasses:
          'text-success-secondary border border-solid border-success-secondary',
      };
    case 'MANUAL':
      return {
        letter: 'M',
        label: 'Manual',
        colorClasses:
          'text-primary-blue border border-solid border-primary-blue',
      };
    default:
      return {
        letter: 'E',
        label: 'External',
        colorClasses:
          'text-inactive-text border border-solid border-inactive-text',
      };
  }
};

export default HintLegend;
